import {USER_ROOT_API_URL} from "../../../../config/settings.js"

export const GET_MYPAGE_INFORMATION = USER_ROOT_API_URL +  "/get_user_basic_information/"
export const GET_MYPAGE_FRIENDS = USER_ROOT_API_URL +  "/get_random_friends/"
export const GET_MYPAGE_POSTS = USER_ROOT_API_URL +  "/get_user_posts/"
export const GET_PRESIGNED_URL = USER_ROOT_API_URL +  "/get_presigned_url/"
export const DELETE_POST = USER_ROOT_API_URL +  "/delete_post/";
